import type {
  CreateTaskInput,
  DeleteRecordsInput,
  MoveTaskToStatusInput,
  ReorderTaskWithinStatusInput,
  TaskBulkPatch,
  UpdateTaskInput
} from '@shared/types';
import { showUndoToastForLastAction } from '@renderer/app/undo/undo-toast';
import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function listTasks() {
  return getDesktopApi().tasks.listTasks();
}

export async function moveTaskToStatus(payload: MoveTaskToStatusInput) {
  const result = await getDesktopApi().tasks.moveTaskToStatus(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function reorderTaskWithinStatus(payload: ReorderTaskWithinStatusInput) {
  const result = await getDesktopApi().tasks.reorderTaskWithinStatus(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function createTask(payload: CreateTaskInput) {
  return getDesktopApi().tasks.createTask(payload);
}

export async function updateTask(payload: UpdateTaskInput) {
  const result = await getDesktopApi().tasks.updateTask(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function applyBulkTaskPatch(payload: TaskBulkPatch) {
  const result = await getDesktopApi().tasks.applyBulkPatch(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function deleteTasks(payload: DeleteRecordsInput) {
  const result = await getDesktopApi().tasks.deleteTasks(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function listDeletedTasks() {
  return getDesktopApi().tasks.listDeletedTasks();
}

export async function restoreTasks(payload: DeleteRecordsInput) {
  return getDesktopApi().tasks.restoreTasks(payload);
}

export async function purgeTasks(payload: DeleteRecordsInput) {
  return getDesktopApi().tasks.purgeTasks(payload);
}
